import type { FeatureDefinitionGroup, FeatureExtractionVisibility } from '../feature-definition-types';

export type PaymentsRelativePath = '/invoices' | '/payouts' | '/payment-plans';

export const featureDefinition = {
  root: '/payments',
  iconName: 'payments',
  items: {
    '/invoices': {
      label: 'Requests',
      trackingId: 'nav-payments-invoices',
      description:
        'Lists all issued invoices and payment requests, with options to view details, send to customers, or track payment status.',
    },
    '/payouts': {
      label: 'Payouts',
      trackingId: 'nav-payments-payouts',
      description:
        'Shows disbursements/payouts received or pending to your practice account, including settlement dates and amounts.',
    },
    '/payment-plans': {
      label: 'Payment Plans',
      trackingId: 'nav-payments-payment-plans',
      description:
        'Create and manage recurring billing plans for patients or clients, including installment schedules and balances.',
    },
  },
} as const satisfies FeatureDefinitionGroup<'/payments', 'payments', PaymentsRelativePath>;

export const featureExtractionVisibility = {
  itemShowClassifications: {
    '/invoices': 'runtime-conditional',
    '/payouts': 'runtime-conditional',
    '/payment-plans': 'runtime-conditional',
  },
} as const satisfies FeatureExtractionVisibility<PaymentsRelativePath>;
